import {
  Button,
  Card,
  CardText,
  CardTitle,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Col,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { setWindowScrollYPosition } from "../../../store/job/action";
import { Link } from "react-router-dom";
import { DateHelper } from "@workspace/common";
import "./JobDetails.scss";

export default function JobDetailsOffcanvas({
  selectedJob,
  handleCanvasClose,
  canvasOpen,
}) {
  const { id, submissionData } = selectedJob;
  const dispatch = useDispatch();

  // Parse submissionData to JSON object
  const job = JSON.parse(submissionData);

  // Save scroll position in localStorage when user clicks on Apply Now button
  function handleScrollPosition() {
    dispatch(setWindowScrollYPosition(window.scrollY));
  }

  return (
    <Offcanvas
      direction="bottom"
      isOpen={canvasOpen}
      backdrop={false}
      style={{ height: "80%" }}
      className="jobdetails-offcanvas"
    >
      <OffcanvasHeader toggle={handleCanvasClose}>
        {job.jobTitle}
      </OffcanvasHeader>
      <OffcanvasBody className="pt-0">
        <Card className="shadow-none">
          <Row className="mx-0 mb-3">
            <Col className="d-flex align-items-center justify-content-between px-0">
              <div className="d-flex align-items-center">
                <i className="las la-map-marker me-1" />
                <CardText className="color-slategray">
                  {job.country}, {job.workLocation}
                </CardText>
              </div>
            </Col>
          </Row>
          <Row className="d-flex align-items-start m-0 py-2 bg-light rounded">
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="ri-briefcase-line" />
              </div>
              <small className="color-slategray">JOB ID</small>
              <h6 className="mt-1">{job?.jobId}</h6>
            </Col>
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-calendar-blank-outline" />
              </div>
              <small className="color-slategray">DATE POSTED</small>
              <h6 className="mt-1">
                {DateHelper.formatDateStandard2(job?.dateOpen)}
              </h6>
            </Col>
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-timer-outline" />
              </div>
              <small className="color-slategray">JOB EXPIRE IN</small>
              <h6 className="mt-1">
                {DateHelper.formatDateStandard2(job?.targetClosingDate)}
              </h6>
            </Col>
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-layers-triple-outline" />
              </div>
              <small className="color-slategray">WORK MODE</small>
              <h6 className="mt-1">{job?.workType}</h6>
            </Col>
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="ri-wallet-line" />
              </div>
              <small className="color-slategray">SALARY</small>
              <h6 className="mt-1">{job?.payrate}</h6>
            </Col>
            <Col className="flex-center-column" xs="4" md="2">
              <div className="d-flex align-items-center">
                <i className="ri-building-line" />
              </div>
              <small className="color-slategray">JOB-TYPE</small>
              <h6 className="mt-1">{job?.jobType}</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className="flex-center w-100 my-3 bg-trueblue"
                tag={Link}
                to={`/job-portal/${id}`}
                onClick={handleScrollPosition}
              >
                Apply Now
                <i
                  className="mdi mdi-arrow-right ms-1"
                  style={{ fontSize: "1.25rem" }}
                />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <CardTitle tag="h5" className="mb-3">
                Job Description
              </CardTitle>
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                className="fs-15 color-blackcoral"
                dangerouslySetInnerHTML={{ __html: job.Jobdescription }}
              />
            </Col>
          </Row>
        </Card>
      </OffcanvasBody>
    </Offcanvas>
  );
}
